// removed by extract-text-webpack-plugin
module.exports = {"container":"_2OmhB","dot":"_2UkhZ","opacitychange":"_9iVxk"};


//////////////////
// WEBPACK FOOTER
// ./app/components/loader/loader.scss
// module id = 963
// module chunks = 0 3 4 5 6